<template>
  <div class="at-home">
    <EventTeamSwiper />
    <TrackfieldMatchTabbar  @setComponent="setComponent" ref="matchbar"/>
    <component :is="component" @scoreDetail="scoreDetail"></component>
  </div>
</template>

<script>
import EventTeamSwiper from '@comm/components/match/components/EventTeamSwiper.vue';
import TrackfieldSchedule from './components/TrackfieldSchedule.vue';
import TrackfieldMatchTabbar from './components/TrackfieldMatchTabbar.vue';
import TrackfieldAthlete from './components/TrackfieldAthlete.vue';
import TrackfieldMedalTable from './components/TrackfieldMedalTable.vue';
import TrackfieldAchievement from './components/TrackfieldAchievement.vue';
import TrackPaylerDetail from './components/TrackPaylerDetail.vue';
export default {
  name:"TrackFieldHome",
  components: {
    EventTeamSwiper,
    TrackfieldSchedule,
    TrackfieldMatchTabbar,
    TrackfieldMedalTable,
    TrackfieldAchievement,
    TrackfieldAthlete,
    TrackPaylerDetail,
  },
  data() {
    return {
        component:"TrackfieldSchedule",
    }
  },
  methods: {
    //更新组件
    setComponent(name){
        this.component=name
    },
    //成绩详情
    scoreDetail(item){
        this.$refs.matchbar.handleTab(item,2)
    }
  },
}
</script>

<style lang="scss" scoped>
.at-home{
    width: 100%;
    padding-top: 30px;
    
}
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/TrackFieldHome.vue